// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ColumnsContainer } from "@components";
import type { Rows } from "@components/columns-container/types";
import { formatDate } from "@transformers/date";

type Props = $Exact<{
  data: Object,
  ...PropsFromLocalize,
}>;

export class AbsenceMonitoringSettingsView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [
              [this.props.t("ABSENCE_MONITORING_PROCESS_ID_TITLE"), this.props.data.id],
              [this.props.t("ABSENCE_MONITORING_PROCESS_NAME_TITLE"), this.props.data.content.name],
            ],
          },
          {
            data: [
              [
                this.props.t("STATUS"),
                this.props.data.content.isActive
                  ? this.props.t("ACTIVE")
                  : this.props.t("INACTIVE"),
              ],
            ],
          },
          {
            data: [
              [this.props.t("START_DATE"), formatDate(this.props.data.content.activeFrom || null)],
              [this.props.t("END_DATE"), formatDate(this.props.data.content.activeTo || null)],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(AbsenceMonitoringSettingsView);
